import { render, staticRenderFns } from "./StudentReportCard.vue?vue&type=template&id=471fab0f&scoped=true&"
import script from "./StudentReportCard.vue?vue&type=script&lang=js&"
export * from "./StudentReportCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471fab0f",
  null
  
)

export default component.exports